module.exports = __webpack_public_path__ + "static/media/zl_2_17.1fad807e.png";